<ng-container
  *ngIf="{
    activeIdentity: activeIdentity$ | async
  } as state"
>
  @if (!!state.activeIdentity) {
    <app-layout></app-layout>
  } 
</ng-container>

<ng-container *ngIf="bannerService.banners$ | async as banners">
  <app-banner
    [tid]="'cookie-consent-banner'"
    class="cookie-consent-banner"
    *ngFor="let banner of banners | keyvalue"
    [bannerName]="banner.key"
    [contentType]="banner.value"
    bannerType="basic"
    marginBottom="0"
    padding=" 2rem 1rem"
    [centerContent]="true"
  ></app-banner>
</ng-container>

<router-outlet name="top"></router-outlet>
